//import liraries
import React, { Component,useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import CHeader from '../../common/CHeader';
import CImage from '../../common/CImage';
import CText from '../../common/CText';
import { getOptOut} from "../../api/maxProApi";
import ModalAlert from '../../common/ModalAlert';
import { COLORS, FONTS } from '../../constant';
import * as RootNavigation from "../../utilities/RootNavigation";
import Loader from '../../common/Loader';

// create a component
const MPBenefits = (props) => {
    const styles = useStyles();
    const [loading, setLoading] = useState(false);
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [optOutSuccess, setOptOutSuccess] = useState(false);
    const [optOutConfrimModal, setOptOutConfrimModal] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        actionButton: "",
    });
   
      const onCloseModal = () => {
        setAlertModalVisible(false);
        if(optOutSuccess == true){
          RootNavigation.navigate("Home", {
            screen: "Home",
            params: { screen: "" },
          })
        }
    };
    const onCloseOptOutConfirmModal = () =>{
      setOptOutConfrimModal(false)
      onCLickMPOptOut()
    }
      const onCLickMPOptOut = () => {
        let param = {
            customerId: "",
            vrn: global.selectedVehicleForMax,
            requestType: "OPT-OUT",
        }
        setLoading(true)
        console.log(param,'req obj optOut')
        getOptOut(param).then(res => {
            setLoading(false)
            if (res?.statusCode == 200 || res?.statusCode == 1103) {
                console.log(res?.data, "Oput Out response")
                setAlertModal({
                  title: "Successful",
                  status: "success",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
              });
              setAlertModalVisible(true);
              setOptOutSuccess(true)

            } else if (res?.statusCode < 0 || res?.statusCode == 500 || res?.statusCode == -1103 || res?.statusCode == -1104) {
                setAlertModal({
                    title: res?.statusCode == -1104 ? 'Already Opted Out':"Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
                setAlertModalVisible(true);
            }

        }).catch(err => {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
        });
        setAlertModalVisible(true);
        })
    }
    return (
        <View style={styles.container}>
           {loading && <Loader />}
         {console.log(global.selectedVehicleForMax,'global.selectedVehicleForMax23')}
             <CHeader showBack onPress={() => {
              RootNavigation.navigate("Dashboard")
              global.activeScreen="Dashboard"
            }} 
              title={"FASTag MAX Benefits"}  />
              <View style={styles.optOutBtn}>
                <TouchableOpacity onPress={()=>setOptOutConfrimModal(true)} style={{flexDirection:'row',alignItems:'center'}}>
                  <Text style={styles.optOutBtnText}>{"Opt-out of FASTag MAX"}</Text>
                  <CImage.MpOptOutIcon></CImage.MpOptOutIcon>
                </TouchableOpacity>
              </View>
            <View style={styles.bannerContainer}>
            
                <View style={styles.bannerLowBal}>
                    <CImage.MPBenefitBanner05></CImage.MPBenefitBanner05>
                </View>
                <View style={styles.bannerLowBalMobile}>
                    <CImage.MPBannerLowBalMobile></CImage.MPBannerLowBalMobile>
                </View>
                <View style={{flexDirection:'column'}}>
                    <TouchableOpacity onPress={() => props.setActiveScreen("benefitDetails")}>
                        <CImage.MPBenefitBanner01></CImage.MPBenefitBanner01>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => props.setActiveScreen("benefitDetails")}>
                        <CImage.MPBenefitBanner02></CImage.MPBenefitBanner02>
                    </TouchableOpacity>
                </View>
                <View style={{flexDirection:'column'}}>
                <TouchableOpacity onPress={() => props.setActiveScreen("benefitDetails")}>
                        <CImage.MPBenefitBanner03></CImage.MPBenefitBanner03>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => props.setActiveScreen("benefitDetails")}>
                        <CImage.MPBenefitBanner04></CImage.MPBenefitBanner04>
                    </TouchableOpacity>
                </View>
            </View>
            {alertModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={onCloseModal}
                    />
                </View>
            ) : null}
            
            {
              optOutConfrimModal ? (
                <View style={styles.overlayViewStyle}>
                <View style={styles.overlayContainer}>
                    <View style={styles.overlay}>
                        <View style={styles.overlayContentViewStyle}>
                            <CText.enterOtpText style={{paddingTop:10,fontSize:18,paddingBottom:21}}>{"Confirm"}</CText.enterOtpText>
                           
                            <CImage.ErrorIconWithBg></CImage.ErrorIconWithBg>
                            <CText.otpDescText style={{paddingTop:30,color:'#585a5f',opacity:1,lineHeight:20}}>
                            
                           { "Are you sure you want to Opt-out of FASTag MAX? No refund will be processed & your benefits will stay active until your subscription expires on "}
                           {global.mpExipryDate}.
                            </CText.otpDescText>
                            <View
                                style={styles.footerMultipleBtn}
                            >
                                <TouchableOpacity onPress={() => {setOptOutConfrimModal(false) }} >
                                  <CText.optOutConfirmText style={{paddingLeft:30}}>{"Cancel"}</CText.optOutConfirmText>
                                </TouchableOpacity>
                                <View style={{backgroundColor:COLORS.boderColor,width:1,height:50}}/>
                                <TouchableOpacity onPress={() => {onCloseOptOutConfirmModal() }}>
                                  <CText.optOutConfirmText style={{paddingRight:30}}>{"Yes"}</CText.optOutConfirmText>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
              )
            :null}
           
        </View>
    );
};

// define your styles
const useStyles = CreateResponsiveStyle(
    {
      container: {
        width: "100%",
      },
      bannerContainer:{
        flexDirection:'row', 
        marginVertical:40, 
        marginHorizontal:25,
    },
    lowbalWidget:{
        borderWidth:2,
        borderRadius:6,
        borderColor:COLORS.yellow200,
        maxWidth:300,
        marginRight:30,
        marginTop:15,
        alignItems:'center',
        justifyContent:'center',
        padding:20,
        textAlign:'center'
    },
    bannerLowBal:{
        marginTop:12,
        marginRight:20
    },
    bannerLowBalMobile:{
        height:0,
        display:'none'
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      minHeight: 500,
      top: 0,
      left: 0,
      borderRadius: 10,
      alignItems: "center",
      paddingTop:20
  },
  optOutBtn:{
     width:200,
     alignSelf:'flex-end',
     marginTop:-50,
     marginRight:0
    },
    optOutBtnText:{
      fontFamily: FONTS.Inter,
      fontSize: 13,
      color: COLORS.blue300,
      marginRight:8,
      fontWeight:'600'
    },
    overlayContentViewStyle: {
      width: 360,
      height: 390,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
          width: 0,
          height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
  },
  footerMultipleBtn:{
    flexDirection:'row',
    justifyContent:'space-between',
    borderTopWidth:1,
    borderColor:COLORS.boderColor,
    paddingHorizontal:20,
    alignItems:'center',
    marginTop:60
  }

    },
  
    {
      [DEVICE_SIZES.XL]: {
        container: {},
      },
      [DEVICE_SIZES.LG]: {
      },
      [DEVICE_SIZES.MD]: {
        container: {
          flexDirection: "column",
          minHeight:600
        },
        overlayViewStyle:{
          alignSelf:"center",
          paddingTop:"25%"
        },
        bannerContainer:{
            marginHorizontal:8,
            flexWrap:'wrap',
            justifyContent:'center'
        }
      },
      [DEVICE_SIZES.SM]: {
        container: {
          flexDirection: "column",
          
        },
        optOutBtn:{
          width:150
        },
        overlayContentViewStyle:{
          width:'96%',
          height:410
        }
      },
      [DEVICE_SIZES.XS]: {
        container: {
          width: "100%",
        },
        bannerContainer:{
            flexDirection:'column', 
            marginVertical:25, 
            marginHorizontal:10
        },
        bannerLowBal:{
            marginTop:0,
            marginRight:0,
            height:0,
            display:'none'
        },
        bannerLowBalMobile:{
            marginTop:12,
            marginBottom:20,
            height:120,
            display:'flex'
        },
        optOutBtn:{
          width:110
        },
        overlayContentViewStyle:{
          width:'96%',
          height:410
        }
      },
      
    }
  );
//make this component available to the app
export default MPBenefits;
